(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mpaz-cart-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mpaz-cart-upsell')) {
    class MpazCartUpsell extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.list = this.querySelector('ul');
        this.addEventListener('click', event => this.onClick(event), { signal });
        this.list.addEventListener('scroll', () => this.updateNavigation(), { passive: true, signal });
        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
        this.resizeObserver.observe(this.list);
        this.drawer = this.closest('cart-drawer');
        if (this.drawer && !this.drawer.classList.contains('is-visible')) {
          this.observer = new MutationObserver(() => {
            if (this.drawer.classList.contains('is-visible')) {
              this.observer.disconnect();
              this.load();
            }
          });
          this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
        } else this.load();
      }
      disconnectedCallback() {
        this.controller.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
      }
      updateNavigation() {
        const offset = Math.abs(this.list.scrollLeft);
        this.querySelector('[data-slide="-1"]').disabled = offset < 2;
        this.querySelector('[data-slide="1"]').disabled = offset >= this.list.scrollWidth - this.list.clientWidth - 2;
      }
      onClick(event) {
        const slide = event.target.closest('[data-slide]');
        if (slide) {
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          this.list.scrollBy({ left: Number(slide.dataset.slide) * direction * this.list.clientWidth * .9, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      }
      async load() {
        const ids = this.dataset.productIds.split(',');
        const excluded = new Set(ids);
        const chosen = new Map();
        try {
          for (const id of ids.slice(0, 3)) {
            const url = new URL(this.dataset.url, location.origin);
            url.search = new URLSearchParams({ section_id: 'mpaz-cart-upsell', product_id: id, limit: '10', intent: 'complementary' });
            const response = await fetch(url, { signal: this.controller.signal });
            if (!response.ok) continue;
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            this.collect(html.querySelectorAll('[data-upsell-product]'), excluded, chosen);
            if (chosen.size >= 6) break;
          }
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
        if (!this.isConnected) return;
        this.collect(this.querySelector('[data-fallback]').content.querySelectorAll('[data-upsell-product]'), excluded, chosen);
        this.list.replaceChildren(...chosen.values());
        this.hidden = chosen.size === 0;
        this.updateNavigation();
      }
      collect(cards, excluded, chosen) {
        for (const card of cards) {
          const id = card.dataset.upsellProduct;
          if (!excluded.has(id) && !chosen.has(id) && chosen.size < 6) chosen.set(id, card.cloneNode(true));
        }
      }
    }
    customElements.define('mpaz-cart-upsell', MpazCartUpsell);
  }
  } catch(e) { console.error(e); }
})();

})();
